// extracted by mini-css-extract-plugin
module.exports = {"root":"Box_root__1LyRS","interactive":"Box_interactive__cH2pl"};